import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;
const staticServerBaseURL = process.env.REACT_APP_STATIC_SERVER_URL;

export const getCreators = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/creators`, { params });
};

export const getCreator = async (params) => {
  return await axios.get(`${baseURL}/creator/`, { params });
};

export const addCreator = async (values) => {
  return await axios.post(`${baseURL}/creator`, values);
};

export const addCreatorCommission = async (values) => {
  return await axios.post(`${baseURL}/creator-commission`, values);
};

export const updateCreatorInfo = async (university, values) => {
  return await axios.put(`${baseURL}/creator/${university}`, values);
};
